import { render } from "./DepartmentForm.vue?vue&type=template&id=7edb1f75&scoped=true"
import script from "./DepartmentForm.vue?vue&type=script&lang=ts"
export * from "./DepartmentForm.vue?vue&type=script&lang=ts"

import "./DepartmentForm.vue?vue&type=style&index=0&id=7edb1f75&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7edb1f75"

export default script